let accountSelectors;
let accountActions;
let isLoaded = false;
function injectAccountDucks(selectors, actions) {
    accountSelectors = selectors;
    accountActions = actions;
    isLoaded = true;
}

function selectUserLoggedIn(state) {
    if (!isLoaded) {
        return false;
    }

    return accountSelectors.selectUserLoggedIn(state);
}

function selectUserInfo(state) {
    if (!isLoaded) {
        return {};
    }

    return accountSelectors.selectUserInfo(state);
}

function selectIdentityId(state) {
    if (!isLoaded) {
        return;
    }

    return accountSelectors.selectIdentityId(state);
}

function selectIsNewAccount(state) {
    if (!isLoaded) {
        return false;
    }

    return accountSelectors.selectIsNewAccount(state);
}

function logOut() {
    return (dispatch) => {
        if (!isLoaded) {
            return;
        }

        dispatch(accountActions.logOut());
    };
}

function autoLogIn() {
    return (dispatch) => {
        if (!isLoaded) {
            return;
        }

        dispatch(accountActions.autoLogIn());
    };
}

const selectors = {
    selectIdentityId,
    selectIsNewAccount,
    selectUserLoggedIn,
    selectUserInfo,
};
const actions = {
    logOut,
    autoLogIn,
};

export {
    actions,
    injectAccountDucks,
    selectors,
};
